module.exports = __webpack_public_path__ + "img/bg_bot.16f7d6d0.png";